import BaseSelector, { hookFromSelector, withStaticSelector } from './BaseSelector'

class ScoreTiersSelector extends BaseSelector {
	static fromStoreState(store) {
		return new this(store.scoreTiers)
	}

	/**
	 * @class ScoreTiersSelector
	 * @property {function(storeState: Object): array} selectData
	 * @property {function(): array} useData
	 */
	@hookFromSelector('useData')
	@withStaticSelector
	selectData() {
		return this.state.items
	}

	/**
	 * @class ScoreTiersSelector
	 * @property {function(storeState: Object, id: number): Object} selectItem
	 * @property {function(id: number): Object} useItem
	 */
	@hookFromSelector('useItem')
	@withStaticSelector
	selectItem(id) {
		return _.find(this.selectData(), { id })
	}
}

export default ScoreTiersSelector
